var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRighticon = function SvgArrowRighticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.046 12.796-6.75 6.75a1.127 1.127 0 0 1-1.594-1.594l4.83-4.827H3.75a1.125 1.125 0 1 1 0-2.25h13.781l-4.827-4.83a1.127 1.127 0 1 1 1.594-1.594l6.75 6.75a1.124 1.124 0 0 1-.002 1.595"
  })));
};
export default SvgArrowRighticon;